import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { Icon } from '../../index';
import usePickerInput from '../hooks/use-picker-input';
import { getInputSize, getRangePlaceholder, elementsContains, getValue, updateValues } from '../utils';

function InputDate(props, ref) {
  var _classnames, _context, _classnames2, _context2, _classnames3, _context3, _classnames4;

  var startInputRef = props.startInputRef,
      endInputRef = props.endInputRef,
      startInputDivRef = props.startInputDivRef,
      endInputDivRef = props.endInputDivRef,
      separatorRef = props.separatorRef,
      panelDivRef = props.panelDivRef,
      activeBarPositionStyle = props.activeBarPositionStyle,
      activeBarWidth = props.activeBarWidth,
      id = props.id,
      autoFocus = props.autoFocus,
      allowClear = props.allowClear,
      className = props.className,
      borderType = props.borderType,
      mergedDisabled = props.mergedDisabled,
      mergedActivePickerIndex = props.mergedActivePickerIndex,
      startHoverValue = props.startHoverValue,
      endHoverValue = props.endHoverValue,
      startText = props.startText,
      endText = props.endText,
      picker = props.picker,
      propsPlaceholder = props.placeholder,
      style = props.style,
      size = props.size,
      needConfirmButton = props.needConfirmButton,
      dateValue = props.dateValue,
      selectedValue = props.selectedValue,
      startOpen = props.startOpen,
      endOpen = props.endOpen,
      separator = props.separator,
      suffixIcon = props.suffixIcon,
      clearIcon = props.clearIcon,
      format = props.format,
      open = props.open,
      readOnly = props.readOnly,
      prefixCls = props.prefixCls,
      locale = props.locale,
      dataOrAriaProps = props.dataOrAriaProps,
      _onFocus = props.onFocus,
      onBlur = props.onBlur,
      onMouseDown = props.onMouseDown,
      onMouseUp = props.onMouseUp,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onContextMenu = props.onContextMenu,
      onClick = props.onClick,
      resetStartText = props.resetStartText,
      resetEndText = props.resetEndText,
      setSelectedValue = props.setSelectedValue,
      triggerStartTextChange = props.triggerStartTextChange,
      triggerEndTextChange = props.triggerEndTextChange,
      _triggerOpen = props.triggerOpen,
      triggerChange = props.triggerChange,
      triggerOpenAndFocus = props.triggerOpenAndFocus,
      setMergedActivePickerIndex = props.setMergedActivePickerIndex,
      setHoverRangedValue = props.setHoverRangedValue;
  var preventBlurRef = useRef(false);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMouseEnter = _useState2[0],
      setIsMouseEnter = _useState2[1];

  var placeholder = getRangePlaceholder(picker, locale, propsPlaceholder);

  var onInternalonClick = function onInternalonClick(e) {
    if (onClick) {
      onClick(e);
    }

    if (!open && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) {
      if (!mergedDisabled[0]) {
        triggerOpenAndFocus(0);
      } else if (!mergedDisabled[1]) {
        triggerOpenAndFocus(1);
      }
    }
  };

  var onInternalonMouseDown = function onInternalonMouseDown(e) {
    if (onMouseDown) {
      onMouseDown(e);
    }

    if (open) {
      preventBlurRef.current = true;
      requestAnimationFrame(function () {
        preventBlurRef.current = false;
      });
    }

    if (open && (startFocused || endFocused) && !startInputRef.current.contains(e.target) && !endInputRef.current.contains(e.target)) {
      e.preventDefault();
    }
  };

  var clearNode;

  if (allowClear && (getValue(dateValue, 0) && !mergedDisabled[0] || getValue(dateValue, 1) && !mergedDisabled[1])) {
    clearNode = /*#__PURE__*/React.createElement("span", {
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      onMouseUp: function onMouseUp(e) {
        e.preventDefault();
        e.stopPropagation();
        var values = dateValue;

        if (!mergedDisabled[0]) {
          values = updateValues(values, null, 0);
        }

        if (!mergedDisabled[1]) {
          values = updateValues(values, null, 1);
        }

        triggerChange(values);

        _triggerOpen(false, mergedActivePickerIndex);

        setHoverRangedValue([null, null]);
      },
      className: "".concat(prefixCls, "-range-clear")
    }, clearIcon || /*#__PURE__*/React.createElement(Icon, {
      type: "close-solid"
    }));
  }

  var getSuffixNode = function getSuffixNode() {
    if (isMouseEnter && (startHoverValue || endHoverValue || startText || endText) && allowClear) {
      return clearNode;
    }

    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-suffix")
    }, suffixIcon || /*#__PURE__*/React.createElement(Icon, {
      type: picker === 'time' ? 'waiting' : 'date'
    }));
  };

  var getSharedInputHookProps = function getSharedInputHookProps(index, resetText) {
    return {
      preventBlurRef: preventBlurRef,
      blurToCancel: needConfirmButton,
      onBlur: onBlur,
      isClickOutside: function isClickOutside(target) {
        return !elementsContains([panelDivRef.current, startInputDivRef.current, endInputDivRef.current], target);
      },
      onFocus: function onFocus(e) {
        setMergedActivePickerIndex(index);

        if (_onFocus) {
          _onFocus(e);
        }
      },
      triggerOpen: function triggerOpen(newOpen) {
        _triggerOpen(newOpen, index);
      },
      onSubmit: function onSubmit() {
        triggerChange(selectedValue, index);
        resetText();
      },
      onCancel: function onCancel() {
        _triggerOpen(false, index);

        setSelectedValue(dateValue);
        resetText();
      }
    };
  };

  var _usePickerInput = usePickerInput(_extends(_extends({}, getSharedInputHookProps(0, resetStartText)), {
    open: startOpen,
    value: startText
  })),
      _usePickerInput2 = _slicedToArray(_usePickerInput, 2),
      startInputProps = _usePickerInput2[0],
      _usePickerInput2$ = _usePickerInput2[1],
      startFocused = _usePickerInput2$.focused,
      startTyping = _usePickerInput2$.typing;

  var _usePickerInput3 = usePickerInput(_extends(_extends({}, getSharedInputHookProps(1, resetEndText)), {
    open: endOpen,
    value: endText
  })),
      _usePickerInput4 = _slicedToArray(_usePickerInput3, 2),
      endInputProps = _usePickerInput4[0],
      _usePickerInput4$ = _usePickerInput4[1],
      endFocused = _usePickerInput4$.focused,
      endTyping = _usePickerInput4$.typing;

  var borderClass = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-underline"), borderType === 'underline'), _defineProperty(_classnames, "".concat(prefixCls, "-borderless"), borderType === 'none'), _classnames));

  var mouseEnterHandle = function mouseEnterHandle(e) {
    setIsMouseEnter(true);

    if (typeof onMouseEnter === 'function') {
      onMouseEnter(e);
    }
  };

  var mouseLeaveHandle = function mouseLeaveHandle(e) {
    setIsMouseEnter(false);

    if (typeof onMouseLeave === 'function') {
      onMouseLeave(e);
    }
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: classnames(prefixCls, "".concat(prefixCls, "-range"), className, borderClass, (_classnames2 = {}, _defineProperty(_classnames2, _concatInstanceProperty(_context = "".concat(prefixCls, "-")).call(_context, size), size), _defineProperty(_classnames2, "".concat(prefixCls, "-disabled"), mergedDisabled[0] && mergedDisabled[1]), _defineProperty(_classnames2, "".concat(prefixCls, "-focused"), mergedActivePickerIndex === 0 ? startFocused : endFocused), _classnames2)),
    style: style,
    onMouseDown: onInternalonMouseDown,
    onMouseUp: onMouseUp,
    onMouseEnter: mouseEnterHandle,
    onMouseLeave: mouseLeaveHandle,
    onContextMenu: onContextMenu,
    onClick: onInternalonClick
  }, dataOrAriaProps), /*#__PURE__*/React.createElement("div", {
    className: classnames("".concat(prefixCls, "-input"), (_classnames3 = {}, _defineProperty(_classnames3, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 0), _defineProperty(_classnames3, "".concat(prefixCls, "-input-placeholder"), !!startHoverValue), _defineProperty(_classnames3, _concatInstanceProperty(_context2 = "".concat(prefixCls, "-input-")).call(_context2, size), size), _classnames3)),
    ref: startInputDivRef
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    ref: startInputRef,
    disabled: mergedDisabled[0],
    readOnly: readOnly || typeof format === 'function' || !startTyping,
    value: startHoverValue || startText,
    onChange: function onChange(e) {
      triggerStartTextChange(e.target.value);
    },
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus: autoFocus,
    placeholder: getValue(placeholder, 0) || ''
  }, startInputProps, {
    size: getInputSize(picker, format)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-range-separator"),
    ref: separatorRef
  }, separator), /*#__PURE__*/React.createElement("div", {
    className: classnames("".concat(prefixCls, "-input"), (_classnames4 = {}, _defineProperty(_classnames4, "".concat(prefixCls, "-input-active"), mergedActivePickerIndex === 1), _defineProperty(_classnames4, "".concat(prefixCls, "-input-placeholder"), !!endHoverValue), _defineProperty(_classnames4, _concatInstanceProperty(_context3 = "".concat(prefixCls, "-input-")).call(_context3, size), size), _classnames4)),
    ref: endInputDivRef
  }, /*#__PURE__*/React.createElement("input", _extends({
    ref: endInputRef,
    disabled: mergedDisabled[1],
    readOnly: readOnly || typeof format === 'function' || !endTyping,
    value: endHoverValue || endText,
    onChange: function onChange(e) {
      triggerEndTextChange(e.target.value);
    },
    placeholder: getValue(placeholder, 1) || ''
  }, endInputProps, {
    size: getInputSize(picker, format)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-active-bar"),
    style: _extends(_extends({}, activeBarPositionStyle), {
      width: activeBarWidth,
      position: 'absolute'
    })
  }), getSuffixNode());
}

export default /*#__PURE__*/React.forwardRef(InputDate);